var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Online Sales","doc":_vm.doc}},[_c('template',{slot:"header"},[_c('YearSelector',{on:{"select":_vm.load}})],1),_c('Sales',{staticClass:"my-5",attrs:{"year":_vm.year}}),_c('Transfers',{ref:"transfers",staticClass:"my-5"}),_c('Payouts',{staticClass:"my-5",attrs:{"id":_vm.managed_account}}),_c('Note',{staticClass:"my-5"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }